import { IProjectDrillingParametersFormationTop } from '../../interfaces/iproject-drilling-parameters-formation-top';
import { FormationTop } from '../formation-top';
import { ProjectDrillingParameter } from '../project-drilling-parameter';

export class ProjectDrillingParametersFormationTopBase {
  ProjectDrillingParametersFormationTopId: number;
  ProjectDrillingParameterId: number | null;
  FormationTopId: number | null;
  OverrideValue: number | null;
  IsOverride: boolean;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  FormationTop?: FormationTop;
  ProjectDrillingParameter?: ProjectDrillingParameter;

  constructor(item?: IProjectDrillingParametersFormationTop) {
    if (item) {

      this.ProjectDrillingParametersFormationTopId = item.ProjectDrillingParametersFormationTopId;
      this.ProjectDrillingParameterId = item.ProjectDrillingParameterId;
      this.FormationTopId = item.FormationTopId;
      this.OverrideValue = item.OverrideValue;
      this.IsOverride = item.IsOverride;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.FormationTop = new FormationTop(item.FormationTop);
      this.ProjectDrillingParameter = new ProjectDrillingParameter(item.ProjectDrillingParameter);
    }
  }
}